var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5033 4.20428L25.7391 0.475993C25.4155 0.170451 24.9856 0 24.5386 0C24.0915 0 23.6616 0.170451 23.3381 0.475993L19.991 3.80122H2.03471C1.49507 3.80122 0.977534 4.01355 0.595952 4.39149C0.21437 4.76943 0 5.28202 0 5.81651V27.9847C0 28.5192 0.21437 29.0318 0.595952 29.4097C0.977534 29.7877 1.49507 30 2.03471 30H24.4165C24.9561 30 25.4737 29.7877 25.8552 29.4097C26.2368 29.0318 26.4512 28.5192 26.4512 27.9847V9.60526L29.5033 6.58232C29.8213 6.26682 30 5.83917 30 5.3933C30 4.94743 29.8213 4.51979 29.5033 4.20428ZM15.0874 18.0392L10.8246 18.9764L11.842 14.7946L21.5577 5.15147L24.8438 8.40616L15.0874 18.0392ZM25.9425 7.25745L22.6565 4.00275L24.5386 2.13861L27.8246 5.3933L25.9425 7.25745Z",
    fill: "#EB3539"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.8cd44a4c54ed169c53a9126cdb06348d.svg";
export { ForwardRef as ReactComponent };